export const translations = {
    sv: {
        general: {
            accept: "Acceptera",
            decline: "Avböj",
            apply: "Tillämpa",
            cancel: "Avbryt",
            confirm: "Bekräfta",
            yes: "Ja",
            no: "Nej",
            close: "Stäng",
        },
        language: {
            title: "Språk",
            swedish: "Svenska",
            english: "Engelska",
        },
        nav: {
            home: "Start",
            search: "Sök",
            saved: "Favoriter",
            profile: "Profil",
            map: "Karta",
            match: "Match",
        },
        home: {
            dateLabel: "11 februari",
            timeLabel: "09:30 - 15:00",
            landing: {
                welcome: "Välkommen till",
                tagline:
                    "Knyt värdefulla kontakter på Karlstad Universitets största jobbmässa. Missa inte chansen!",
                cta: "Sök Montrar",
            },
            host: {
                title: "Ansök till värd",
                body: "Att vara värd ger dig en chans att få nära kontakt med en arbetsgivare du själv väljer.",
                cta: "Till Ansökan",
            },
            map: {
                title: "Företagen på kartan",
                body: "Gå inte vilse i monterdjungeln. Hitta snabbt och smidigt det företag du söker på kartan.",
                cta: "Till Kartan",
            },
            match: {
                title: "Hitta din matchning!",
                body: "Matcha med företag baserat på dina intressen och preferenser. Du kan enkelt komma åt dina matchningar senare bland dina sparade favoritmontrar.",
                cta: "Till Matchningar",
            },
        },
        search: {
            allTitle: "Alla Montrar",
            allEmpty: "Hittade ej några montrar",
            favoritesTitle: "Mina Favoriter",
            favoritesEmpty: "Inga favoriter sparade",
            inputPlaceholder: "T.ex. Sommarjobb Karlstad",
            filter: {
                sort: "Sortera",
                sortAscending: "A-Ö",
                sortDescending: "Ö-A",
                filter: "Filtrera",
                clear: "Rensa Filter",
                applyPreferences: "Tillämpa preferenser",
                resetFilters: "Rensa filter",
                title: "Filter",
                narrowTitle: "Smal sökning",
                narrowDescription:
                    "Filtrerar ut alternativ istället för att inkludera dem.",
                industries: "Branscher",
                services: "Tjänster",
                apply: "Tillämpa",
            },
            results: {
                single: "{count} Monter",
                plural: "{count} Montrar",
            },
        },
        map: {
            searchPlaceholder: "Hitta monter",
        },
        profile: {
            title: "Din Profil",
            preferencesTitle: "Mina preferenser",
            edit: "Ändra",
            industries: "Branscher",
            services: "Tjänster",
            noPreferences: "Inga preferenser valda just nu...",
            otherSettings: "Andra inställningar",
            favoritesTitle: "Favoriter",
            favoritesCountSingle: "{count} favorit sparad",
            favoritesCountPlural: "{count} favoriter sparade",
            favoritesClear: "Rensa favoriter",
            favoritesModalTitle: "Rensa favoriter?",
            favoritesModalDescription:
                "Är du säker på att du vill rensa dina favoriter?",
            linksTitle: "Våra länkar",
        },
        theme: {
            title: "Ändra tema",
        },
        cookies: {
            title: "Cookies",
            description: "Preferenser sparas ej om kakor är av.",
        },
        languageToggle: {
            description: "Välj vilket språk som ska användas i appen.",
        },
        cookiePrompt: {
            message:
                "Den här webbsidan använder cookies för att förbättra användarupplevelsen.",
            accept: "Acceptera",
            decline: "Avböj",
        },
        onboarding: {
            welcomeTitle: "Hitta nya jobbmöjligheter!",
            welcomeBody:
                "Välkommen till Hotspot – din perfekta partner i jakten på spännande karriärmöjligheter! Upptäck en värld av nya jobbmöjligheter skräddarsydda för studenter, direkt i din handflata.",
            skip: "Hoppa över",
            continue: "Gå vidare",
            introTitle: "Välkommen!",
            introBody:
                "Här kan du skapa din personliga profil. Välj vilka branscher och tjänster som du är intresserad av.",
            namePrompt: "Vad heter du?",
            namePlaceholder: "Skriv ditt namn...",
            selectIndustries: "Välj branscher",
            selectServices: "Välj tjänster",
            createProfile: "Skapa profil",
        },
        match: {
            allLikedTitle: "Du har gillat alla företag!",
            allLikedBody:
                "Gå till dina favoriter för att kolla in dem igen.",
            emptyTitle: "Inga fler företag kunde hittas.",
            emptyBody: "Klicka nedan för att ladda om.",
            reload: "Ladda om",
        },
        monter: {
            booth: "Monterplats",
            services: "Tjänster",
            industries: "Branscher",
            jobTitles: "Yrkestitlar",
            locations: "Verksamhetsorter",
            employees: "Antal anställda",
            employeesValue: "{count} anställda",
            description: "Beskrivning",
            globalGoals: "Globala mål",
            map: "Karta",
        },
    },
    en: {
        general: {
            accept: "Accept",
            decline: "Decline",
            apply: "Apply",
            cancel: "Cancel",
            confirm: "Confirm",
            yes: "Yes",
            no: "No",
            close: "Close",
        },
        language: {
            title: "Language",
            swedish: "Swedish",
            english: "English",
        },
        nav: {
            home: "Home",
            search: "Search",
            saved: "Saved",
            profile: "Profile",
            map: "Map",
            match: "Match",
        },
        home: {
            dateLabel: "11 February",
            timeLabel: "09:30 - 15:00",
            landing: {
                welcome: "Welcome to",
                tagline:
                    "Build valuable connections at Karlstad University’s biggest career fair. Don’t miss out!",
                cta: "Browse Booths",
            },
            host: {
                title: "Become a host",
                body: "Being a host lets you connect closely with an employer of your choice.",
                cta: "Apply now",
            },
            map: {
                title: "Booths on the map",
                body: "Don’t get lost among the booths. Quickly find the company you’re looking for.",
                cta: "Open the map",
            },
            match: {
                title: "Find your match!",
                body: "Match with companies based on your interests and preferences. Revisit them later among your saved favourites.",
                cta: "Go to matches",
            },
        },
        search: {
            allTitle: "All booths",
            allEmpty: "No booths found",
            favoritesTitle: "My favourites",
            favoritesEmpty: "No favourites saved yet",
            inputPlaceholder: "E.g. Summer job Karlstad",
            filter: {
                sort: "Sort",
                sortAscending: "A-Z",
                sortDescending: "Z-A",
                filter: "Filter",
                clear: "Clear filters",
                applyPreferences: "Apply preferences",
                resetFilters: "Reset filters",
                title: "Filters",
                narrowTitle: "Strict filtering",
                narrowDescription:
                    "Excludes results that do not match all selected tags.",
                industries: "Industries",
                services: "Opportunities",
                apply: "Apply",
            },
            results: {
                single: "{count} booth",
                plural: "{count} booths",
            },
        },
        map: {
            searchPlaceholder: "Find booth",
        },
        profile: {
            title: "Your profile",
            preferencesTitle: "My preferences",
            edit: "Edit",
            industries: "Industries",
            services: "Opportunities",
            noPreferences: "No preferences selected yet...",
            otherSettings: "Other settings",
            favoritesTitle: "Favourites",
            favoritesCountSingle: "{count} favourite saved",
            favoritesCountPlural: "{count} favourites saved",
            favoritesClear: "Clear favourites",
            favoritesModalTitle: "Clear favourites?",
            favoritesModalDescription:
                "Are you sure you want to remove all favourites?",
            linksTitle: "Our links",
        },
        theme: {
            title: "Change theme",
        },
        cookies: {
            title: "Cookies",
            description: "Preferences are not stored when cookies are disabled.",
        },
        languageToggle: {
            description: "Choose which language should be used in the app.",
        },
        cookiePrompt: {
            message:
                "This website uses cookies to improve your experience.",
            accept: "Accept",
            decline: "Decline",
        },
        onboarding: {
            welcomeTitle: "Discover new job opportunities!",
            welcomeBody:
                "Welcome to Hotspot – your perfect partner in the search for exciting career opportunities. Explore a world of student-focused roles right in your hand.",
            skip: "Skip",
            continue: "Continue",
            introTitle: "Welcome!",
            introBody:
                "Create your personal profile by selecting the industries and opportunities you are interested in.",
            namePrompt: "What is your name?",
            namePlaceholder: "Type your name...",
            selectIndustries: "Choose industries",
            selectServices: "Choose opportunities",
            createProfile: "Create profile",
        },
        match: {
            allLikedTitle: "You have liked every company!",
            allLikedBody: "Head to your favourites to review them again.",
            emptyTitle: "No more companies could be found.",
            emptyBody: "Tap below to refresh the stack.",
            reload: "Reload",
        },
        monter: {
            booth: "Booth location",
            services: "Opportunities",
            industries: "Industries",
            jobTitles: "Job titles",
            locations: "Offices",
            employees: "Number of employees",
            employeesValue: "{count} employees",
            description: "Description",
            globalGoals: "Global Goals",
            map: "Map",
        },
    },
}

export const filterLabelMap = {
    branscher: {
        "Ekonomi och juridik": {
            sv: "Ekonomi och juridik",
            en: "Economics & Law",
        },
        "Hälsa / Vård / Socialt arbete": {
            sv: "Hälsa / Vård / Socialt arbete",
            en: "Health / Care / Social Work",
        },
        Ingenjörsvetenskap: {
            sv: "Ingenjörsvetenskap",
            en: "Engineering",
        },
        IT: {
            sv: "IT",
            en: "IT",
        },
        Lärarutbildning: {
            sv: "Lärarutbildning",
            en: "Teacher education",
        },
        "Musik / dans och kultur": {
            sv: "Musik / dans och kultur",
            en: "Music / Dance & Culture",
        },
        Naturvetenskap: {
            sv: "Naturvetenskap",
            en: "Natural sciences",
        },
        "Samhällsvetenskap och humaniora": {
            sv: "Samhällsvetenskap och humaniora",
            en: "Social sciences & Humanities",
        },
    },
    tjanster: {
        Anställning: {
            sv: "Anställning",
            en: "Employment",
        },
        Trainee: {
            sv: "Trainee",
            en: "Trainee",
        },
        Extrajobb: {
            sv: "Extrajobb",
            en: "Part-time job",
        },
        Examensarbete: {
            sv: "Examensarbete",
            en: "Thesis project",
        },
        Sommarjobb: {
            sv: "Sommarjobb",
            en: "Summer job",
        },
        Praktik: {
            sv: "Praktik",
            en: "Internship",
        },
        Medlemskap: {
            sv: "Medlemskap",
            en: "Membership",
        },
    },
    globalaMal: {
        "1 Ingen fattigdom": {
            sv: "1 Ingen fattigdom",
            en: "1 No poverty",
        },
        "2 Ingen hunger": {
            sv: "2 Ingen hunger",
            en: "2 Zero hunger",
        },
        "3 Hälsa och välbefinnande": {
            sv: "3 Hälsa och välbefinnande",
            en: "3 Good health and wellbeing",
        },
        "4 God utbildning för alla": {
            sv: "4 God utbildning för alla",
            en: "4 Quality education",
        },
        "5 Jämställdhet": {
            sv: "5 Jämställdhet",
            en: "5 Gender equality",
        },
        "6 Rent vatten och sanitet": {
            sv: "6 Rent vatten och sanitet",
            en: "6 Clean water and sanitation",
        },
        "7 Hållbar energi för alla": {
            sv: "7 Hållbar energi för alla",
            en: "7 Affordable and clean energy",
        },
        "8 Anständiga arbetsvillkor och ekonomisk tillväxt": {
            sv: "8 Anständiga arbetsvillkor och ekonomisk tillväxt",
            en: "8 Decent work and economic growth",
        },
        "9 Hållbar industri och innovation samt infrastruktur": {
            sv: "9 Hållbar industri och innovation samt infrastruktur",
            en: "9 Industry, innovation and infrastructure",
        },
        "10 Minskad ojämlikhet": {
            sv: "10 Minskad ojämlikhet",
            en: "10 Reduced inequalities",
        },
        "11 Hållbara städer och samhällen": {
            sv: "11 Hållbara städer och samhällen",
            en: "11 Sustainable cities and communities",
        },
        "12 Hållbar konsumtion och produktion": {
            sv: "12 Hållbar konsumtion och produktion",
            en: "12 Responsible consumption and production",
        },
        "13 Bekämpa klimatförändringen": {
            sv: "13 Bekämpa klimatförändringen",
            en: "13 Climate action",
        },
        "14 Hav och marina resurser": {
            sv: "14 Hav och marina resurser",
            en: "14 Life below water",
        },
        "15 Ekosystem och biologisk mångfald": {
            sv: "15 Ekosystem och biologisk mångfald",
            en: "15 Life on land",
        },
        "16 Fredliga och inkluderande samhällen": {
            sv: "16 Fredliga och inkluderande samhällen",
            en: "16 Peace, justice and strong institutions",
        },
        "17 Genomförande och globalt partnerskap": {
            sv: "17 Genomförande och globalt partnerskap",
            en: "17 Partnerships for the goals",
        },
    },
}
